


import React, { createContext, useReducer } from 'react';
import appReducer, { APP_INITIAL_STATE } from '../reducers/AppReducer';

export const AppContext = createContext({
  ...APP_INITIAL_STATE
});

const AppProvider = ({children}) => {
  const [store, dispatch] = useReducer(appReducer, APP_INITIAL_STATE);
  const { settings } = store

  const toggleAnimation = () => {
    dispatch({
      type: 'TOGGLE_ANIMATION'
    })
  }

  return (
    <AppContext.Provider value={{
      settings,
      toggleAnimation
      }}>
      {children}
    </AppContext.Provider>
  );
};

export default AppProvider;
